import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';
import { paymentActionType } from '../sagas/payment/paymentSaga';

// APIの住所を設定します。
const paymentServices = (action: paymentActionType): any => {
  if (action.paymentType === 'creditcard') {
    return {
      postPayment: () =>
        apiClient.post(
          `${API_BASE_ADDRESS}/mypage/web-payment?customer_id=${action.customerId}&receipt_number=${action.receiptNumber}&shop_id=${action.shopId}
&amount=${action.amount}
&success_url=${API_BASE_ADDRESS}/web-payinfo-pagecon/success
&cancel_url=${API_BASE_ADDRESS}/web-payinfo-pagecon/failure
&error_url=${API_BASE_ADDRESS}/web-payinfo-pagecon/failure
&pagecon_url=${API_BASE_ADDRESS}/web-payinfo-pagecon`,
          null,
        ),
    };
  }
  return {
    postPayment: () =>
      apiClient.post(
        `${API_BASE_ADDRESS}/mypage/web-payment?customer_id=${action.customerId}&receipt_number=${action.receiptNumber}&shop_id=${action.shopId}
&amount=${action.amount}&unpaid_id=${action.unpaidId}
&success_url=${API_BASE_ADDRESS}/web-unpaid-pagecon/success
&cancel_url=${API_BASE_ADDRESS}/web-unpaid-pagecon/failure
&error_url=${API_BASE_ADDRESS}/web-unpaid-pagecon/failure
&pagecon_url=${API_BASE_ADDRESS}/web-unpaid-pagecon`,
        null,
      ),
  };
};

export default paymentServices;
